import BasicLayout from "./BasicLayout";
import InputField from "components/fields/InputField";
import ValidationIcon from "components/ValidationIcon";

const Step5 = ({ state, setState, message, available }) => {
    var licenseSsl = false;
    state.data.licenses.forEach((license) => {
        if (license.active === true) {
            if (license.code === "ssl") {
                licenseSsl = true;
            }
        }
    });

    const handleChange = (event) => {
        const name = event.target.name;
        const value =
            event.target.value +
            (name === "fqdn" && licenseSsl === true ? ".nexiop.net" : "");
        setState((state) => ({
            ...state,
            data: {
                ...state.data,
                [name]: value,
            },
        }));
    };

    return (
        <BasicLayout
            title="FQDN"
            subtitle={
                <>
                    Inserisci l’indirizzo FQDN da assegnare alla tua piattaforma
                    Proxima Onsite.
                    <br />
                    <br />
                    Prendi spunto da questo esempio: nomeazienda.nexiop.net
                    <br />
                    Il nome inserito verrà validato dal nostro sistema.
                    <br />
                    <br />
                    <strong>
                        N.B. Ti suggeriamo di non inserire caratteri speciali
                        come apostrofi, accenti, virgole, ecc. perché non sono
                        supportati.
                    </strong>
                </>
            }
            titleTwo="Configurazione in caso di licenza cluster"
            subtitleTwo={
                <>
                    In caso di acquisto di una licenza cluster, il sistema
                    verificherà e gestirà due ulteriori FQDN, dedicati alle
                    macchine master e backup.
                    <br />
                    <br />
                    Gli indirizzi FQDN avranno il seguente formato:
                    <br />
                    <br />
                    nomescelto001.dominio.estensione <br />
                    nomescelto002.dominio.estensione
                </>
            }
            subtitleThree={
                <>
                    Esempio: <br />
                    nomeazienda.nexiop.net <br />
                    nomeazienda001.nexiop.net <br />
                    nomeazienda002.nexiop.net
                </>
            }
            content={
                <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                    <div className="-mx-2 flex items-stretch">
                        <div className="mx-2 flex-1">
                            <InputField
                                extra="mb-4"
                                label="FQDN*"
                                placeholder=""
                                name="fqdn"
                                type="text"
                                disabled={available === true}
                                value={
                                    state.data.fqdn
                                        ? licenseSsl === true
                                            ? state.data.fqdn.replace(
                                                  ".nexiop.net",
                                                  ""
                                              )
                                            : state.data.fqdn
                                        : ""
                                }
                                onChange={handleChange}
                                required={true}
                                state={
                                    message.hasOwnProperty("errors")
                                        ? message.errors.hasOwnProperty(
                                              "data.fqdn"
                                          )
                                            ? "error"
                                            : null
                                        : null
                                }
                                error={
                                    message.hasOwnProperty("errors")
                                        ? message.errors.hasOwnProperty(
                                              "data.fqdn"
                                          )
                                            ? message.errors["data.fqdn"]
                                            : null
                                        : null
                                }
                            />
                        </div>

                        {licenseSsl ? (
                            <div className="mx-2 mt-3 shrink-0 self-center">
                                <p>.nexiop.net</p>
                            </div>
                        ) : null}

                        {(available ||
                            (message && !!Object.keys(message).length)) && (
                            <ValidationIcon available={available} />
                        )}
                    </div>
                </div>
            }
        />
    );
};

export default Step5;
